import { useState } from "react";
import "./AffiliateCenter.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function AffiliateProfile({ onShowMembers }) {
  const navigate = useNavigate();
  const [selectedSource, setSelectedSource] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showMember, setShowMember] = useState(false);

  const hadnleShowMember = () => {
    setShowMember(true);
  };
  const hadnleNotShowMember = () => {
    setShowMember(false);
  };

  const handleSourceChange = (event) => {
    setSelectedSource(event.target.value);
  };

  const handleCheckBox = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleGoToDashboard = () => {
    navigate("/customer/dashboard");
  };

  return (
    <>
      <div className="ac_registration_layout">
        <h4 className="mb-4">Market Coupon Code</h4>
        
        <div className="ac_form_container">
          <Row>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>Add Coupon Code</Form.Label>
              <Form.Control className="ac_input" placeholder="e.g. SUMMER20" />
            </Col>
          </Row>
          
          <Row>
            <Col md={6} className="ac_form_group mb-4">
              <Form.Label>Source</Form.Label>
              <Form.Select 
                className="ac_input" 
                value={selectedSource} 
                onChange={handleSourceChange}
              >
                <option value="">Select from dropdown</option>
                <option value="1">Others</option>
                <option value="2">Multiple Sources</option>
                <option value="3">Social Media</option>
              </Form.Select>
            </Col>
          </Row>

          {selectedSource === "1" && (
            <div className="ac_form_group others_info_section p-4 bg-light rounded mb-4">
              <p className="fw-bold mb-3">Other Sources</p>
              <Row>
                <Col md={6} className="mb-3">
                  <Form.Label>Name of Source</Form.Label>
                  <Form.Control className="ac_input" placeholder="Source Name" />
                </Col>
                <Col md={6} className="mb-3">
                  <Form.Label>URL</Form.Label>
                  <Form.Control className="ac_input" placeholder="https://example.com" />
                </Col>
              </Row>
            </div>
          )}
        </div>

        <div className="ac_consent_section">
          <label className="ac_checkbox_wrapper mb-3">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckBox}
              className="ac_checkbox_input"
            />
            <span className="checkbox_text">
              I hereby agree that I own, or have rights to all the above sources provided.
            </span>
          </label>
          <p className="ac_helper_text mt-2">
            Verification may be required for certain sources to ensure compliance with our affiliate policies.
          </p>
        </div>

        <div className="ac_registration_footer">
          <button
            className={`ac_next_btn ${!isChecked ? 'disabled' : ''}`}
            disabled={!isChecked}
            onClick={hadnleShowMember}
          >
            Become an Affiliate Member
          </button>
        </div>
        
        <Modal
          show={showMember}
          onHide={hadnleNotShowMember}
          centered
          className="custom_modal"
        >
          <Modal.Body className="p-0">
            <div className="congrats_modal_container">
              <div className="congrats_icon_box">
                <img
                  src="/build/congratulation.svg"
                  alt="Success"
                  width={80}
                  height={80}
                />
              </div>
              
              <h5 className="congrats_head">Congratulations</h5>
              <p className="congrats_content">
                You have successfully become an Affiliate member!
              </p>
              
              <div className="modal_actions_flex">
                <button
                  className="modal_btn_cancel"
                  onClick={hadnleNotShowMember}
                >
                  Cancel
                </button>
                <button 
                  className="modal_btn_dashboard" 
                  onClick={handleGoToDashboard}
                >
                  Go To Dashboard
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default AffiliateProfile;
